$(window).scroll(function() {
  const atBottom = $(window).scrollTop() + $(window).height() == $(document).height();
  $(".new-prescription-toggle-container, .product-add-to-bag-container, .join-waitlist-container").each(function () {
    if (atBottom || this.classList.contains("cta-inactive")) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
});